import React from "react";
import { setActiveMenuItem } from "../../actions/menu";
import PERMISSIONS from "../../model/permissions";
import { PAGES } from "../../model/vars";
import { Layout, Screen, SideBar } from "../components/layout";
import Secure from "../components/secure";

export default class Settings extends Screen {

    componentDidMount() {
        setActiveMenuItem({id: PAGES.SETTINGS})
    }

    render() {
        return (
            <Secure
                permissions={[PERMISSIONS.ADMIN_SUPERUSER]}
            >
                <Layout>
                    <SideBar/>
                </Layout>
            </Secure>
        )
    }
}